import { sendGoogleEvent } from '@html/_common/utils';

export default function initiateAwards(common, eventCategory, tourId) {
  const commonJs = common ?? { sendGoogleEvent };
  const eventAction = 'Click - Show All Awards';

  const hideButtonClass = 'ao-tour-awards__show-all--hide';
  const hiddenItemClass = 'ao-tour-awards__item--hidden';
  const visibleItemClass = 'ao-tour-awards__item--visible';

  const $button = $('.js-ao-tour-awards__show-all');

  if (!$button.length) {
    return;
  }

  $button.click(() => {
    const changeTextTo = $button.data('text');
    const currentText = $button.text();

    $button.toggleClass(hideButtonClass);

    $button.data('text', currentText);
    $button.text(changeTextTo);

    $(`.${hiddenItemClass}, .${visibleItemClass}`)
      .toggleClass(visibleItemClass)
      .toggleClass(hiddenItemClass);

    commonJs.sendGoogleEvent(
      eventCategory,
      eventAction,
      tourId,
    );
  });
}
